import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/LanguageContext";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="border-t border-white/5 bg-[#0C0A09] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_flavor-forge-68/artifacts/rz0qyx4s_Firefly_GeminiFlash%202.png"
                alt="What To Cook Logo"
                className="w-7 h-7 rounded-md"
              />
              <span className="font-heading text-lg font-semibold text-white">{t("appName")}</span>
            </div>
            <p className="text-sm text-stone-500 leading-relaxed">
              {t("heroSubtitle")}
            </p>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase font-semibold text-stone-500 mb-4">
              Navigation
            </h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("home")}
              </Link>
              <Link to="/generate" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("generate")}
              </Link>
              <Link to="/pricing" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("pricing")}
              </Link>
            </div>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase font-semibold text-stone-500 mb-4">
              Legal
            </h4>
            <div className="space-y-2">
              <Link to="/privacy" data-testid="footer-privacy" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("privacyTitle")}
              </Link>
              <Link to="/terms" data-testid="footer-terms" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("termsTitle")}
              </Link>
              <Link to="/help" data-testid="footer-help" className="block text-sm text-stone-400 hover:text-amber-500 transition-colors">
                {t("helpTitle")}
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 text-center text-xs text-stone-600">
          &copy; {new Date().getFullYear()} What To Cook. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
